module.exports = {
  lazyload: {
    "about/__information__": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/about/__information__.md"));
            }, "about/__information__")
        })
    },

    "about/why-named-edam_zh": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/about/why-named-edam_zh.md"));
            }, "about/why-named-edam_zh")
        })
    },

    "about/why-needs-edam_zh": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/about/why-needs-edam_zh.md"));
            }, "about/why-needs-edam_zh")
        })
    },

    "advanced/__information__": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/advanced/__information__.md"));
            }, "advanced/__information__")
        })
    },

    "advanced/process": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/advanced/process.md"));
            }, "advanced/process")
        })
    },

    "advanced/process_zh": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/advanced/process_zh.md"));
            }, "advanced/process_zh")
        })
    },

    "advanced/standalone": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/advanced/standalone.md"));
            }, "advanced/standalone")
        })
    },

    "advanced/standalone_zh": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/advanced/standalone_zh.md"));
            }, "advanced/standalone_zh")
        })
    },

    "advanced/test_zh": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/advanced/test_zh.md"));
            }, "advanced/test_zh")
        })
    },

    "advanced/write-loader": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/advanced/write-loader.md"));
            }, "advanced/write-loader")
        })
    },

    "advanced/write-loader_zh": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/advanced/write-loader_zh.md"));
            }, "advanced/write-loader_zh")
        })
    },

    "advanced/write-plugin": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/advanced/write-plugin.md"));
            }, "advanced/write-plugin")
        })
    },

    "advanced/write-plugin_zh": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/advanced/write-plugin_zh.md"));
            }, "advanced/write-plugin_zh")
        })
    },

    "advanced/write-template": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/advanced/write-template.md"));
            }, "advanced/write-template")
        })
    },

    "advanced/write-template_zh": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/advanced/write-template_zh.md"));
            }, "advanced/write-template_zh")
        })
    },

    "awesome/autocompete": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/awesome/autocompete.md"));
            }, "awesome/autocompete")
        })
    },

    "features": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/features.md"));
            }, "features")
        })
    },

    "features_zh": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/features_zh.md"));
            }, "features_zh")
        })
    },

    "index": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/index.md"));
            }, "index")
        })
    },

    "index_zh": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/index_zh.md"));
            }, "index_zh")
        })
    },

    "usage/__information__": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/usage/__information__.md"));
            }, "usage/__information__")
        })
    },

    "usage/installation": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/usage/installation.md"));
            }, "usage/installation")
        })
    },

    "usage/installation_zh": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/usage/installation_zh.md"));
            }, "usage/installation_zh")
        })
    },

    "usage/options": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/usage/options.md"));
            }, "usage/options")
        })
    },

    "usage/options_zh": function () {
        return new Promise(function (resolve) {
            require.ensure([], function (require) {
                resolve(require("!!/home/travis/build/imcuttle/edam/node_modules/picidae/lib/lib/loaders/markdown-loader/index.js!/home/travis/build/imcuttle/edam/_site/doc/usage/options_zh.md"));
            }, "usage/options_zh")
        })
    },
  },
  meta: {
  "about/__information__": {
    "title": "关于",
    "title_zh": "关于",
    "order": 0,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "about/__information__.md"
  },
  "about/why-named-edam_zh": {
    "title": "为什么叫edam",
    "order": 1,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "about/why-named-edam_zh.md"
  },
  "about/why-needs-edam_zh": {
    "title": "为什么需要edam?",
    "order": 0,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "about/why-needs-edam_zh.md"
  },
  "advanced/__information__": {
    "title": "Advanced",
    "title_zh": "高级",
    "order": 2,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "advanced/__information__.md"
  },
  "advanced/process": {
    "title": "Principle",
    "order": 1,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "advanced/process.md"
  },
  "advanced/process_zh": {
    "title": "执行流程",
    "order": 1,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "advanced/process_zh.md"
  },
  "advanced/standalone": {
    "title": "独立cli",
    "order": 6,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "advanced/standalone.md"
  },
  "advanced/standalone_zh": {
    "title": "独立cli",
    "order": 6,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "advanced/standalone_zh.md"
  },
  "advanced/test_zh": {
    "title": "单元测试",
    "order": 7,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "advanced/test_zh.md"
  },
  "advanced/write-loader": {
    "title": "Write a Loader",
    "order": 3,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "advanced/write-loader.md"
  },
  "advanced/write-loader_zh": {
    "title": "书写Loader",
    "order": 3,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "advanced/write-loader_zh.md"
  },
  "advanced/write-plugin": {
    "title": "Write a plugin ⚠WIP",
    "order": 5,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "advanced/write-plugin.md"
  },
  "advanced/write-plugin_zh": {
    "title": "书写插件 ⚠WIP",
    "order": 5,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "advanced/write-plugin_zh.md"
  },
  "advanced/write-template": {
    "title": "Write a template",
    "order": 2,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "advanced/write-template.md"
  },
  "advanced/write-template_zh": {
    "title": "书写模板",
    "order": 2,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "advanced/write-template_zh.md"
  },
  "awesome/autocompete": {
    "title": "安装",
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "awesome/autocompete.md"
  },
  "features": {
    "title": "Features",
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "features.md"
  },
  "features_zh": {
    "title": "特性",
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "features_zh.md"
  },
  "index": {
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "index.md"
  },
  "index_zh": {
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "index_zh.md"
  },
  "usage/__information__": {
    "title": "Usage",
    "title_zh": "使用",
    "order": 1,
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "usage/__information__.md"
  },
  "usage/installation": {
    "title": "Installation",
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "usage/installation.md"
  },
  "usage/installation_zh": {
    "title": "安装",
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "usage/installation_zh.md"
  },
  "usage/options": {
    "title": "Options",
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "usage/options.md"
  },
  "usage/options_zh": {
    "title": "选项",
    "datetime": "2021-04-22T15:46:20+00:00",
    "filename": "usage/options_zh.md"
  }
}
,
  plugins: [(require('/home/travis/build/imcuttle/edam/node_modules/picidae-plugin-utils/index.js').default || require('/home/travis/build/imcuttle/edam/node_modules/picidae-plugin-utils/index.js'))({})],
  transformers: [(require('/home/travis/build/imcuttle/edam/node_modules/picidae/lib/transformers/img-loader/browser.js').default || require('/home/travis/build/imcuttle/edam/node_modules/picidae/lib/transformers/img-loader/browser.js'))({})]
};


// WEBPACK FOOTER //
// ../~/picidae/lib/lib/tmp/data.80bb834f.js